export const topBarHeight = "77px";
export const topBarHeightSubtitle = "90px";
export const topBarHeightSubtitleTop = "90px";
export const topBarHeightBothSubtitles = "96px";
export const appLoaderHeight = 2;
export const savebarHeight = "64px";
export const borderHeight = "1px";
